
const initialRequestPercentage = 0

export default {
  namespaced: true,
  state: {
    title: '',
    briefSummary: '',
    proposalDescription: '',
    rationale: '',
    implementationPlan: '',
    timeline: '',
    expectedOutcomes: '',
    totalAmount: 0,
    initialRequest: initialRequestPercentage,
    titleError: null,
    briefSummaryError: null,
    proposalDescriptionError: null,
    rationaleError: null,
    implementationPlanError: null,
    timelineError: null,
    expectedOutcomesError: null,
    totalAmountError: null,
    initialRequestError: null
  },
  getters: {
    formData: state => {
      return {
        title: state.title,
        briefSummary: state.briefSummary,
        proposalDescription: state.proposalDescription,
        rationale: state.rationale,
        implementationPlan: state.implementationPlan,
        timeline: state.timeline,
        expectedOutcomes: state.expectedOutcomes,
        totalAmount: state.totalAmount,
        initialRequest: state.initialRequest
      }
    }
  },
  mutations: {
    setTitle (state, title) {
      state.title = title
    },
    setBriefSummary (state, briefSummary) {
      state.briefSummary = briefSummary
    },
    setProposalDescription (state, proposalDescription) {
      state.proposalDescription = proposalDescription
    },
    setRationale (state, rationale) {
      state.rationale = rationale
    },
    setImplementationPlan (state, implementationPlan) {
      state.implementationPlan = implementationPlan
    },
    setTimeline (state, timeline) {
      state.timeline = timeline
    },
    setExpectedOutcomes (state, expectedOutcomes) {
      state.expectedOutcomes = expectedOutcomes
    },
    setTotalAmount (state, totalAmount) {
      state.totalAmount = totalAmount
    },
    setInitialRequest (state, initialRequest) {
      state.initialRequest = initialRequest
    },
    setTitleError (state, titleError) {
      state.titleError = titleError
    },
    setBriefSummaryError (state, briefSummaryError) {
      state.briefSummaryError = briefSummaryError
    },
    setProposalDescriptionError (state, proposalDescriptionError) {
      state.proposalDescriptionError = proposalDescriptionError
    },
    setRationaleError (state, rationaleError) {
      state.rationaleError = rationaleError
    },
    setImplementationPlanError (state, implementationPlanError) {
      state.implementationPlanError = implementationPlanError
    },
    setTimelineError (state, timelineError) {
      state.timelineError = timelineError
    },
    setExpectedOutcomesError (state, expectedOutcomesError) {
      state.expectedOutcomesError = expectedOutcomesError
    },
    setTotalAmountError (state, totalAmountError) {
      state.totalAmountError = totalAmountError
    },
    setInitialRequestError (state, initialRequestError) {
      state.initialRequestError = initialRequestError
    },
    clear (state) {
      state.title = ''
      state.briefSummary = ''
      state.proposalDescription = ''
      state.rationale = ''
      state.implementationPlan = ''
      state.timeline = ''
      state.expectedOutcomes = ''
      state.totalAmount = 0
      state.initialRequest = initialRequestPercentage
    }
  },
  actions: {
    // async createJob ({ commit, getters }) {
    //   const data = getters.formData
    //   const job = await Jobs.create(data)
    //   commit('adminJobs/addJob', job, { root: true })
    // },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dao-community.js